import { selectLanguageBasedOnBrowserLocale } from 'locale'
import { createSelector } from 'reselect'
import type { State } from 'store/types'
import { emptyObject } from 'utils'

import type { VisibilitySettings } from './types'

export const userLanguage = (state: State) => state.user.settings.language || selectLanguageBasedOnBrowserLocale().toUpperCase()

export const userPrivileges = (state: State): Partial<VisibilitySettings> =>
  Object.keys(state.user.settings).reduce(
    (previous, current) =>
      current.endsWith('Visibility')
        ? {
            ...previous,
            [current]: (state.user.settings as any)[current],
          }
        : previous,
    {},
  ) || emptyObject

export const selectPermission = (permission: keyof VisibilitySettings) =>
  createSelector(userPrivileges, privileges => privileges[permission] || false)

export const showChannelChart = (state: State) => state.user.settings.dataViewType === 1
